// extracted by mini-css-extract-plugin
export default {"name":"tileContent_name__UC781","theme":"tileContent_theme__Zy9Ow","age":"tileContent_age__68MgV","region":"tileContent_region__4y7da"};